// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".spv-light-nodes .normal-table-wrap[data-v-cb112834] .normal-table .node-status.is-no-subscribe{color:var(--base-color-danger)}.spv-light-nodes .normal-table-wrap[data-v-cb112834] .normal-table .node-status.is-subscribe{color:var(--base-color-success)}.spv-light-nodes .normal-table-wrap[data-v-cb112834] .normal-table .node-status.is-no-working{color:#ffb013}", ""]);
// Exports
module.exports = exports;
